import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useQuizzes(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getQuizzes() {
    return privateFetch.get(`/v1/admin/quiz${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['quiz-lists', { data }], getQuizzes, { enabled, keepPreviousData: true });
}

export default useQuizzes;
